import { Theme } from '@material-ui/core';

export const muiTableOverrides = (theme: Theme): Theme['overrides'] => ({
  MuiTableCell: {
    head: {
      fontFamily: 'Poppins',
      lineHeight: '24px',
      color: theme.palette.text.primary,
      fontWeight: 700,
    },
    root: {
      borderBottom: 0,
    },
    stickyHeader: {
      backgroundColor: theme.palette.common.white,
    },
  },
  MuiTableSortLabel: {
    root: {
      '&$active&$active&$active $icon': {
        color: theme.palette.primary.main,
      },
    },
  },
});
